
import React from 'react';
import { CommonModule, UCAModule } from "uca-react-containers-library";

const ForgotPasswordComponent = () => {
    return (
        <CommonModule.ViewportProvider>
            <UCAModule.ForgotPassword />
        </CommonModule.ViewportProvider>
    );
};

export default ForgotPasswordComponent;
